import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import DownPayment from "../../../containers/modules/accounting/down-payment";

export default function DownPaymentRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="down-payment"
      index
      element={
        <AccessControl
          name={"Down Payment List"}
          auth={authUser}
          component={() => <DownPayment />}
        />
      }
    />
  );
}
